<template>
  <div class="header">
    <div class="title-box">
      <div class="logo">
        <a href="http://www.bwxm.net/">
          <img src="@/assets/pc/images/reference/bowai.png" alt=""
        /></a>
      </div>
      <div class="tab-list">
        <div>
          <router-link to="/referenceIndex">
            首页
          </router-link>
        </div>
        <div>
          <router-link to="/">
            药品商城
          </router-link>
        </div>
        <div @click="maskShow = true">国内上市药品</div>
        <div @click="maskShow = true">一次性进口药品</div>
        <div
          class="news-center"
          @mouseenter="showNews = true"
          @mouseleave="showNews = false"
        >
          新闻中心
          <Icon type="chevron-down" class="down"></Icon>
          <div class="news-menu" v-if="showNews">
            <ul>
              <li>
                <router-link to="/referenceNew?index=0">
                  行业资讯
                </router-link>
              </li>
              <li>
                <router-link to="/referenceNew?index=1">
                  政策法规
                </router-link>
              </li>
              <li>
                <router-link to="/referenceNew?index=2">
                  医药快讯
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <router-link to="/referenceUs">联系我们</router-link>
        </div>
        <div class="phone">
          <img src="@/assets/pc/images/reference/phone.png" alt="" />
        </div>
      </div>
    </div>
    <ReferenceMask :maskShow="maskShow" @close="close"></ReferenceMask>
  </div>
</template>

<script>
import ReferenceMask from "@/components/pc/reference/ReferenceMask";
export default {
  name: "ReferenceHead",
  components: {
    ReferenceMask
  },
  data() {
    return {
      maskShow: false,
      showNews: false
    };
  },
  methods: {
    close() {
      this.maskShow = false;
    }
  }
};
</script>

<style lang="stylus" scoped>
.header
  min-width 1200px
  height 80px
  background #fff
  border-bottom 1px solid #eee
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  z-index 1
  .title-box
    width 1200px
    margin 0 auto
    display flex
    justify-content space-between
    .logo
      width 230px
      height 80px
      display flex
      align-items center
      img
        width 100%
        display block
    .tab-list
      display flex
      justify-content space-between
      >div
        line-height 80px
        padding 0 20px
        font-size 16px
        font-family "微软雅黑", Arial
        color #555
        cursor pointer
        &:hover
          color #4496ee
      a
        color #555
      .news-center
        position relative
        &:hover
          .down
            transform rotate(180deg)
        .news-menu
          position absolute
          left -10px
          top 68px
          ul
            box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
            border-radius: 10px;
            background #fff
            li
              height 35px
              width 122px
              line-height 35px
              text-align center
              font-size 14px
              color #666
              &:hover
                color #4496ee
              a
                &:hover
                  color #4496ee
      .down
        transition all 0.5s linear
      .phone
        display flex
        align-items center
</style>
